import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=1bad886a&scoped=true&"
import script from "./Products.vue?vue&type=script&lang=js&"
export * from "./Products.vue?vue&type=script&lang=js&"
import style0 from "./Products.vue?vue&type=style&index=0&id=1bad886a&prod&scoped=true&lang=css&"
import style1 from "./Products.vue?vue&type=style&index=1&id=1bad886a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bad886a",
  null
  
)

export default component.exports